<loader></loader>
<div *ngIf="isFullScreenRoute" style="width:100%;height:100vh;">
  <router-outlet></router-outlet>
</div>
<div *ngIf="!isFullScreenRoute" class="container">
  <div  class="row clsRowNoMargin">
    <app-header *ngIf="isUserAuthorized" [displayUserName]="userName" [userImage]="userImage"></app-header>
    <div *ngIf="(showForbiddenMessage!='appLoad' && showForbiddenMessage!='userAuthorized')">
        <header id="header">
            <div class="layout-center-wrapper">
              <div class="row noMargin container_header">
                <div class="col-md-11">
                <div class="header__logo">
                  <img style="width: 80px;margin-right: 10px;" src="assets/images/DeloitteLogo.png" />
                  <span>|</span>&nbsp;&nbsp;PNS</div>
                </div>
              </div>
            </div>
          </header>
    </div>
  </div>
  
  <div class="row clsRowNoMargin" style="display: -webkit-box;">
      <div [hidden]="!isUserAuthorized" class="col-md-2 sidebar">
        <app-sidebar  [hidden]="!isUserAuthorized" ></app-sidebar>
      </div>
      <div [ngClass]="isUserAuthorized?'main':''" class="col-md-10">
        <router-outlet *ngIf="!isIframe && !isUserInactive"></router-outlet>
        <div [hidden]="!(showForbiddenMessage!='appLoad' && showForbiddenMessage!='userAuthorized')">
          <div class="unauthorizedCls">
        <img src="assets/images/401-unauthorized-error.png">
        <p class="clsAccessDeniedTxt">Access Denied</p>
        <p>Contact <a href="mailto:usitsmobilecoreservicesadmins@deloitte.com" class="clsCursorPointer">usitsmobilecoreservicesadmins@deloitte.com</a> for assistance</p>
      </div>
      </div>
      </div>
  </div>
  
  <div [hidden]="!isUserAuthorized" class="row clsRowNoMargin">
    <div class="cell footerDiv">
      <app-footer></app-footer>
    </div>
  </div>
</div>
